import "../styles/ShopFilters.css";

export default function ShopFilters({ cats, active, onChange, label = "Filter:" }) {
  return (
    <div className="shop-filters">
      <span className="filter-label">{label}</span>
      {cats.map((c) => (
        <button
          key={c}
          className={`filter-btn${active === c ? " active" : ""}`}
          onClick={() => onChange(c)}
        >
          {c}
        </button>
      ))}
    </div>
  );
}
